import { Title } from "@mantine/core";
import React from "react";

export default function MyStuff() {
  return <Title ta="center">My Stuff Page</Title>;
}
